module.exports = __webpack_public_path__ + "img/prize_headimg.833d2842.jpg";